import { EmployeeDocument } from '../Employees/queryBuilder';
import { GroundControlSetDocument } from '../GroundControlSet/queryBuilder';
import { GroundHazardDocument } from '../GroundHazard/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  HazardLogDocument,
  hazardLogPushQueryBuilder,
  hazardLogsPullQueryBuilder,
} from './queryBuilder';

export function hazardLogsFamilyMember(
  configBuilder: ConfigBuilder,
  // Note that `ground_hazard_log` does not depend on `ground_control_set`.
  // However, `ground_hazard_log_ground_control_set` depends on both,
  // and the `CreateGroundHazardLog` mutation does take a `groundControlSets` parameter,
  // so we need to depend on `groundControlSets` here.
  groundControlSets: FamilyMember<GroundControlSetDocument>,
  groundHazards: FamilyMember<GroundHazardDocument>,
  employees: FamilyMember<EmployeeDocument>,
): FamilyMember<HazardLogDocument> {
  const syncConfig = configBuilder<HazardLogDocument>(RxdbCollectionNameV2.HAZARD_LOGS);
  doNotAutoSync(syncConfig);

  // Note that `hazardLogsPullQueryBuilder` actually uses the `groundHazardLogFeed` query,
  // and thus corresponds to the `ground_hazard_log` table in the database.
  pull(syncConfig, hazardLogsPullQueryBuilder);
  push(syncConfig, hazardLogPushQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy had the `retryTime` set to 7500.
  return create(RxdbCollectionNameV2.HAZARD_LOGS, replicationState, [
    groundControlSets,
    groundHazards,
    employees,
  ]);
}
